import { React, useEffect } from "react";
import "./style.css";

function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="relative w-full h-full py-[50px] terms-conditions">
      <div className="relative max-w-[1140px] mx-auto px-4">
        <h1 className="text-[30px] md:text-[45px] laptop:text-[56px] font-semibold leading-none laptop:leading-[56px] tracking-tighter laptop:-tracking-[1px] text-white">
          Terms and Conditions Vanar DPoS
        </h1>
        <h2>1. Introduction to the Terms</h2>
        <div className="list">
          <p>
            These Terms of Use outline the terms and conditions under which you,
            either personally or on behalf of an entity (“you” or “your”), may
            access, interact with, or otherwise use the Interfaces or Features
            provided by Vanar Chain (together with its affiliates, “Vanar
            Chain,” “we,” “us,” or “our”). These Terms of Use, along with any
            appended documents, additional terms, or policies, as well as our
            Privacy Policy (collectively, the “Terms”), form a binding agreement
            between you and us.
          </p>
          <p>
            These Terms apply to (i) all content, functionality, and features
            (the “Content Features”) available on any website or graphical user
            interface hosted by Vanar Chain where the Terms are posted (each an
            “Interface”) and (ii) software operated or hosted by Vanar Chain, or
            made available via an Interface (the “Technology Features” and,
            together with the Content Features, the “Features”).
          </p>
          <p>
            <strong>NOTICE:</strong> PLEASE REVIEW THESE TERMS CAREFULLY. BY
            ACCESSING, INTERACTING WITH, OR USING ANY INTERFACE OR FEATURE, YOU
            AGREE THAT YOU CAN ENTER INTO A BINDING AGREEMENT AND HAVE READ,
            UNDERSTOOD, AND AGREE TO BE BOUND BY THESE TERMS, INCLUDING THE
            BINDING ARBITRATION AGREEMENT AND CLASS ACTION WAIVER BELOW. IF YOU
            DO NOT AGREE TO ALL TERMS, YOU ARE NOT AUTHORIZED TO INTERACT WITH,
            ACCESS, OR USE ANY INTERFACE OR FEATURE.
          </p>
        </div>
        <h2>2. Interfaces and Features</h2>
        <h3 className="mb-2 text-base">
          a) Overview of Interfaces and Features
        </h3>
        <div className="list">
          <p>
            Each Interface has distinct functionality: some Interfaces are
            informational, while others allow users to engage with blockchain
            networks in a self-directed manner. None of the Interfaces enable us
            to engage in transactions with you directly, nor do they facilitate
            your transactions. Even when Interfaces seem dynamic (e.g., updating
            displays when you provide specific information), Vanar Chain is not
            taking action on your behalf.
          </p>
          <p>
            If you use the “Connect Wallet” feature, which links your
            self-hosted cryptocurrency wallet (“Wallet”) to interact with a
            blockchain network, please note that Vanar Chain (i) does not
            transmit information to blockchain networks, (ii) cannot assist in
            any transaction, (iii) cannot access or control your Wallet or your
            crypto assets, and (iv) does not provide transaction support.
          </p>
          <p>
            You are responsible for familiarizing yourself with your Wallet,
            including any security features, private keys, and passwords. Vanar
            Chain will not and cannot access your private key, password, or any
            assets held within your Wallet and cannot reverse any transaction
            initiated with your Wallet.
          </p>
          <p>
            You should also be aware of the risks associated with blockchain
            networks, including vulnerabilities in smart contracts, front-end
            vulnerabilities, hacking risks, phishing, crypto asset volatility,
            and transaction irreversibility.
          </p>
          <p>
            Vanar Chain does not control, maintain, provide, or operate any
            underlying blockchain protocols used by the tools and applications
            displayed on the Interfaces. We do not effectuate, facilitate, or
            control transactions and assume no responsibility for any resulting
            transaction loss, error, or failure.
          </p>
          <p>
            All transactions on the blockchain network via your Wallet may
            require the payment of network transaction fees, which are
            non-refundable and your responsibility.
          </p>
        </div>
        <h3 className="mb-2 text-base">b) Acknowledgment of Information</h3>
        <div className="list">
          <p>
            You acknowledge that all information provided through the Interfaces
            is for informational purposes only. While Vanar Chain aims to
            provide accurate information, it does not guarantee that the
            information is up-to-date, complete, or free from errors. You agree
            not to rely on any information from the Interfaces for any purpose
            and (i) disclaim any reliance on information within the Features and
            (ii) acknowledge that Vanar Chain is not liable for any information
            provided.
          </p>
          <p>
            You should verify any information on any Interface independently and
            avoid making decisions based solely on content provided in the
            Interfaces. None of the information on the Interfaces constitutes
            professional or investment advice.
          </p>
        </div>
        <h2>3. Modifications</h2>
        <div className="list">
          <p>
            We reserve the right, in our sole discretion, to modify these Terms
            at any time. Updated Terms will be posted on an Interface with an
            updated date. By continuing to access, use, or interact with any
            Interface or Feature after the modification, you agree to be bound
            by the modified Terms. If you disagree with any updates, you are
            prohibited from using the Interfaces or Features.
          </p>
          <p>
            Vanar Chain also reserves the right to modify or discontinue any
            Interface or Feature at its discretion, with or without notice.
          </p>
        </div>
        <h2>4. Your Responsibilities and Representations</h2>
        <h3 className="mb-2 text-base">a) Your Representation</h3>
        <div className="list">
          <p>
            The Interfaces and Features are intended only for users 18 years or
            older. If you are entering into the Terms on behalf of an entity,
            you represent that you have the legal authority to bind that entity.
            If you do not meet these requirements, you may not use the
            Interfaces or Features.
          </p>
          <p>
            You represent and warrant that you are not subject to economic or
            trade sanctions, nor included on lists of prohibited parties. If
            your status changes, you must cease using the Interfaces and
            Features immediately.
          </p>
          <p>
            You are responsible for properly configuring and securing your data,
            financial or token information, and private keys when using the
            Features.
          </p>
        </div>
        <h3 className="mb-2 text-base">
          b) Your Responsibilities & Prohibited Conduct
        </h3>
        <p className="mb-2">
          You agree to use the Interfaces and Features appropriately, in
          compliance with these Terms and applicable laws.
        </p>
        <p className="mb-2">You agree that you will not:</p>
        <ul>
          <li>Violate any laws or the Terms;</li>
          <li>Exploit the Interfaces or Features for unauthorized purposes;</li>
          <li>
            Collect information from the Interfaces or Features without
            authorization;
          </li>
          <li>
            Reverse engineer or disassemble any software included in the
            Interfaces or Features;
          </li>
          <li>
            Use data mining tools or similar to extract data from the Interfaces
            or Features;
          </li>
          <li>Introduce harmful software to the Interfaces or Features;</li>
          <li>
            Attempt unauthorized access to any Interfaces or Features, servers,
            or networks;
          </li>
          <li>
            Attack the Interfaces or Features with denial-of-service attacks.
          </li>
        </ul>
        <p className="mb-2">
          If you use an Interface or Feature in a prohibited manner, we may
          investigate or take action as deemed necessary.
        </p>
        <p className="mb-2">
          Using the Interfaces or Features may have tax consequences. You are
          responsible for determining any tax obligations resulting from your
          transactions and ensuring compliance with applicable tax laws.
        </p>
        <h3 className="mb-2 text-base">c) Your Feedback</h3>
        <p>
          Feedback submitted through the Interfaces is welcome but not required
          to be reviewed by Vanar Chain. Any feedback provided will become Vanar
          Chain’s property, and by submitting it, you grant us a license to use
          it for our business purposes.
        </p>
        <h2>5. Intellectual Property Rights</h2>
        <h3 className="mb-2 text-base">a) Ownership & License</h3>
        <p className="mb-2">
          Vanar Chain or its licensors own all rights, title, and interest in
          the Interfaces and Features. Vanar Chain grants you a personal,
          limited, revocable license to use the Interfaces and Features, subject
          to the Terms.
        </p>
        <h3 className="mb-2 text-base">b) Reciprocal License</h3>
        <p>
          By using any Interface or Feature, you grant Vanar Chain a license to
          use any content or feedback you provide for business purposes.
        </p>
        <h2>6. Third-Party Information or Services</h2>
        <p>
          The Interfaces may include links to or integrations with third-party
          services. Vanar Chain is not responsible for the content, accuracy,
          availability, or privacy practices of third-party services. Access to
          third-party services is at your own risk and may be subject to
          additional terms.
        </p>
        <h2>7. Indemnification</h2>
        <p>
          You agree to indemnify and hold harmless Vanar Chain and its
          affiliates from all claims arising from your use of the Interfaces or
          Features, including violations of the Terms.
        </p>
        <h2>8. Disclaimers and Limitations of Liability</h2>
        <h3 className="mb-2 text-base">a) Interfaces and Features</h3>
        <p className="mb-2">
          Vanar Chain does not guarantee the functionality, security, or
          availability of the Interfaces or Features and provides them on an “AS
          IS” basis.
        </p>
        <h3 className="mb-2 text-base">b) Limitations of Liability</h3>
        <p>
          Vanar Chain is not liable for any indirect or incidental damages, and
          its aggregate liability under these Terms.
        </p>
        <h2>9. Governing Law, Dispute Resolution, and Class Action Waiver</h2>
        <h3 className="mb-2 text-base">a) Governing Law</h3>
        <p className="mb-2">
          These Terms are governed by the laws of the United Arab Emirates.
        </p>
        <h3 className="mb-2 text-base">b) Dispute Resolution</h3>
        <p className="mb-2">
          You agree to attempt to resolve disputes with Vanar Chain through good
          faith negotiations before commencing any legal proceeding. If
          unresolved, disputes will be settled by arbitration in the United Arab
          Emirates.
        </p>
        <h3 className="mb-2 text-base">
          c) Mandatory Arbitration Provision and Class Action Waiver
        </h3>
        <p>
          Disputes must be resolved individually in arbitration, waiving the
          right to a class action.
        </p>
        <h2>10. No Relationship or Assignment</h2>
        <p>
          These Terms do not create any partnership, joint venture, or agency
          relationship between you and Vanar Chain. You may not assign your
          rights or obligations, but Vanar Chain may transfer the Terms.
        </p>
        <h2>11. Entire Agreement</h2>
        <p>
          The Terms constitute the entire agreement between you and Vanar Chain
          regarding the Interfaces and Features.
        </p>
        <h2>12. No Waiver</h2>
        <p>
          Vanar Chain’s failure to enforce any provision of the Terms does not
          constitute a waiver of such provision.
        </p>
        <h2>13. Severability</h2>
        <p>
          If any portion of the Terms is held invalid, the remaining portions
          will remain in full effect.
        </p>
      </div>
    </div>
  );
}

export default TermsAndConditions;
